import { t } from 'ttag';

const SEND_REQUEST = t`Send Request`;

export default SEND_REQUEST;
